import React from 'react';
import { FaHeartbeat, FaRobot, FaBrain, FaFlask, FaChartLine } from 'react-icons/fa';

const LoadingSpinner = ({ message = 'Loading...', showAI = false }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="relative mb-8">
        {/* Main Spinner Circle */}
        <div className="w-24 h-24 rounded-full bg-neo-bg border-4 border-neo-main 
                      flex items-center justify-center animate-spin shadow-neo-brutal" style={{ animationDuration: '3s' }}>
          <div className="w-20 h-20 rounded-full bg-white border-2 border-neo-main 
                        flex items-center justify-center">
            <FaHeartbeat className="text-4xl text-neo-accent animate-pulse" />
          </div>
        </div>
        
        {/* AI Robot Icon Badge */}
        {showAI && (
          <div className="absolute -top-2 -right-2 w-10 h-10 bg-neo-accent border-2 border-neo-main 
                        rounded-lg flex items-center justify-center shadow-neo-sm animate-bounce-soft z-10">
            <FaRobot className="text-white text-lg" />
          </div>
        )}

        {/* Loading Dots */}
        <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2">
          <div className="flex gap-2">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="w-3 h-3 bg-neo-main rounded-full animate-bounce"
                style={{ animationDelay: `${i * 0.15}s` }}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="text-center max-w-md">
        <h3 className="text-xl font-black text-neo-main mb-2 uppercase tracking-tight">{message}</h3>
        {showAI && (
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-neo-card border-2 border-neo-main rounded-md shadow-neo-sm">
            <FaBrain className="text-neo-accent animate-pulse" />
            <span className="text-sm font-bold text-neo-text">AI Analysis in Progress</span>
          </div>
        )}
      </div>

      {showAI && (
        <div className="mt-8 w-full max-w-sm">
          <div className="flex justify-between items-center mb-2">
            <span className="text-xs font-black text-neo-text uppercase tracking-wide">
              Analysis Progress
            </span>
            <span className="text-xs font-bold text-neo-accent bg-white px-2 py-0.5 border border-neo-main rounded">
              Processing...
            </span>
          </div>
          
          <div className="h-4 bg-white border-2 border-neo-main rounded-full overflow-hidden p-0.5">
            <div className="h-full bg-neo-accent rounded-full animate-pulse" 
                 style={{ 
                   width: '100%', 
                   backgroundImage: 'linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)',
                   backgroundSize: '1rem 1rem'
                 }}>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-4 gap-3">
            {[
              { icon: FaFlask, label: 'Beers' },
              { icon: FaChartLine, label: 'STOPP' },
              { icon: FaBrain, label: 'ACB' },
              { icon: FaHeartbeat, label: 'TTB' },
            ].map((item, index) => (
              <div
                key={item.label}
                className="flex flex-col items-center gap-2 animate-fade-in"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="w-10 h-10 bg-white border-2 border-neo-main rounded-lg 
                              flex items-center justify-center shadow-neo-sm animate-pulse"
                     style={{ animationDelay: `${index * 0.3}s` }}>
                  <item.icon className="text-neo-text text-sm" />
                </div>
                <span className="text-xs font-bold text-neo-text-sub uppercase">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
